import { client } from "./axiosConfig";



export const signIn = (data) => {
    return client.post("/user/login", data);
};

export const verifyMfaCode = (code) => {
    return client.post("/user/mfa/verify", { code });
};

export const resendMfaCode = () => {
    return client.post("/user/mfa/resend");
};

export const signOut = () => {
    return client.post("/user/logout");
};

export const sendResetPassword = (data) => {
    return client.post("/send-reset-password", data);
};

export const resetPassword = (data) => {
    return client.put("/user/reset-password", data);
};

export const getPaymentStatus = (userId) => {
    return client.get(`/get-payment-status/${userId}`);
};

export const getUserProfile = (userId) => {
    return client.get(`/user/${userId}`);
};

//old - stripe
// export const reconcileCheckoutSession = (data) => {
//     return client.post("/reconcile-checkout-session", data);
// };

export const finalizePlan = (userId) => {
    return client.post(`/finalize-plan/${userId}`);
};